import { z } from "zod/v4"
import { CreatedAt } from "./system"
import { LiveIdSchema, SpaceKeySchema, UserIdSchema } from "../id"

export const MoodSchema = z.enum(["default", "happy", "angry", "sad", "relaxed", "surprised"])
export type Mood = z.infer<typeof MoodSchema>

const LiveEventCommonFields = {
  space_key: SpaceKeySchema,
  live_id: LiveIdSchema,
  user_id: UserIdSchema,
  created_at: CreatedAt,
}

const VoiceEventBody = z.object({
  ...LiveEventCommonFields,
  kind: z.literal("voice"),
  value: z.number(),
})

const VoiceAndMoodEventBody = z.object({
  ...LiveEventCommonFields,
  kind: z.literal("voice-and-mood"),
  value: z.number(),
  mood: MoodSchema,
})

export const LiveEventDocumentBody = z.discriminatedUnion("kind", [VoiceEventBody, VoiceAndMoodEventBody])

export type LiveEventDocumentBody = z.infer<typeof LiveEventDocumentBody>
